import { ENDPIONTS, httpService } from "@api";
import { EvaluationCriterion } from "@models";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

const AddEvaluationCriteriaUnit = () => {
  const { register, handleSubmit, errors } = useForm();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: any, e: any) => {
    setIsLoading(true);

    const obj = {
      unit: data.unit,
      symbol: data.symbol,
    };

    const res = await httpService(ENDPIONTS.ECUnit).post(obj);

    setIsLoading(false);
    e.target.reset();
  };

  return (
    <>
      <h4>Add Evaluation Criteria Unit</h4>
      <hr />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label> Unit</label>
              <div className="col-12">
                <input
                  type="text"
                  className="form-control"
                  name="unit"
                  ref={register({ required: true })}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <div className="form-group">
              <label> Symbol</label>
              <div className="col-12">
                <input
                  type="text"
                  className="form-control"
                  name="symbol"
                  ref={register({ required: true })}
                />
              </div>
            </div>
          </div>
        </div>

        <input
          type="submit"
          name="time"
          className="btn btn-primary"
          disabled={isLoading}
          value={isLoading ? "Please wait..." : "Submit"}
        />
      </form>
    </>
  );
};

export default AddEvaluationCriteriaUnit;
